import { navigate } from "gatsby";
import React from "react";
import CustomButton from "../Button/CustomButtton";
import { diamondIcon, usdcLogo } from "../../images/marketplace";
import { constants } from "../../utils/constants";
import { Sku, SkuStatus, SkuType } from "../../types/Sku";
import { addThousandsSeparator } from "../../utils";

const MarketItem = ({
  item,
  unitImg,
  isMatic = false,
  isHome = false,
}: {
  item: Sku;
  unitImg?: any;
  isMatic?: boolean;
  isHome?: boolean;
}) => {
  const isPurchased = item.status === SkuStatus.OWNED;
  const isClaiming = item.status === SkuStatus.CLAIMING;
  const isAvatar = item.type === SkuType.AVATAR;

  //if item hidden true  donot show to user
  if (!item?.is_visible) return <></>;

  return (
    <div className="rounded shadow">
      {item.tagImg && (
        <img
          src={item.tagImg}
          alt="product_card"
          className={
            isHome
              ? "hidden sm:block absolute lg:mt-[6.5rem] lg:ml-8 lg:w-44"
              : "hidden sm:block absolute mt-40 ml-40 lg:mt-32 lg:ml-32 lg:w-36"
          }
        />
      )}
      <img src={item.coverImg} alt="product_card" className="w-full px-1" />

      <div
        style={{ background: "#393F43" }}
        className=" rounded-lg -mt-[14px] "
      >
        {/** pl and pr different to make heading contain 2 line in order to make same size even if name is long */}
        <h6
          style={{ color: item?.headingColor || "white" }}
          className="font-cinzel text-[24px] leading-8 font-bold pt-6 pb-5 pl-4 pr-8"
        >
          {item.name}
        </h6>
        <hr style={{ border: "1px solid #4F585E" }} />
        <div className="px-4 py-4">
          <p style={{ color: "#B1BDC8" }} className="text-sm leading-6">
            {isAvatar ? "Item Name" : "Items in bundle"}
          </p>
          <h6
            style={{ color: item?.headingColor || "#B1BDC8" }}
            className="pb-2 text-xl font-cinzel leading-8 font-semibold"
          >
            {isAvatar
              ? item.name
              : `${
                  item.parsedContent
                    ? addThousandsSeparator(item.parsedContent["res-silver"])
                    : ""
                } Silvers`}
          </h6>
          <span style={{ color: "#B1BDC8" }} className="text-sm leading-6">
            Price:
          </span>
          <div className="flex items-center justify-start gap-2">
            {!isMatic && (
              <img src={unitImg ? unitImg : usdcLogo} className="w-6 mt-1" />
            )}
            <h3 className="text-[1.75rem] leading-[48px] font-cinzel font-bold pt-2">
              <span className="text-white">
                {isMatic && "$"}
                {item.price}
              </span>
            </h3>
          </div>
          <CustomButton
            onClick={() =>
              navigate(
                `${constants.app_routes.marketplace.purchase}?item=${item._id}`
              )
            }
            icon2={isPurchased || isClaiming ? undefined : diamondIcon}
            text={
              isPurchased ? "Purchased" : isClaiming ? "Pending" : "Buy now"
            }
            btnType={"primary"}
            disabled={isPurchased || isClaiming}
          />
        </div>
      </div>
    </div>
  );
};

export default MarketItem;
